import { bindable } from "aurelia";

export class MessageComponent {
  @bindable messageStyle: 'primary' | 'warning' | 'danger' | 'neutral' | 'success' = "primary"
  @bindable message: string
  @bindable canClose: boolean

  private isClosed: boolean = false

  closeMessage() {
    this.isClosed = true;
  }

  getIcon() {
    switch (this.messageStyle) {
      case 'primary':
        return 'mdi mdi-information-outline';
      case 'warning':
        return 'mdi mdi-alert-outline';
      case 'danger':
        return 'mdi mdi-flag-variant-outline';
      case 'neutral':
        return 'mdi mdi-information-outline';
      case 'success':
        return 'mdi mdi-check-circle-outline';
      default:
        return '';
    }
  }
}